import { useMutation } from '@tanstack/react-query';

import { axios } from '@/src/lib/axios/axios';
import { generateRoutePath } from '@/src/routes';

import { Treatment } from '../types/treatment';

type SaveTreatmentParams = {
  documentId: number;
  params: Treatment['payload'] | Record<string, any>;
  saveTreatmentEndpoint: string;
};

type SaveTreatmentResponse = {
  activities: any;
  transactionId: string;
  transactionDate: string;
  url: string;
};

const saveTreatment = ({
  documentId,
  params,
  saveTreatmentEndpoint,
}: SaveTreatmentParams): Promise<SaveTreatmentResponse> => {
  const url = generateRoutePath(saveTreatmentEndpoint, { documentId });

  return axios.post(url, params, { showError: false });
};

export const useSaveTreatment = () => {
  return useMutation({
    mutationFn: (mutationsParams: SaveTreatmentParams) => saveTreatment(mutationsParams),
  });
};
